import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=1c039582&scoped=true&"
import script from "./tile.vue?vue&type=script&lang=js&"
export * from "./tile.vue?vue&type=script&lang=js&"
import style0 from "./tile.vue?vue&type=style&index=0&id=1c039582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c039582",
  null
  
)

export default component.exports